export default __webpack_public_path__ + "static/media/business woman using AED on man on office floor.9e806d2b.jpg";